import backend from '@common/backend';
import { INewsItemSnapshotIn } from '@common/models/News/NewsItem';

const BASE = '/news';

export const newsItemFromBE = (newsItem: any) => ({
	// @TODO: Remove when BE will be fixed
	...newsItem,
	service: newsItem.service_id || null,
	reactions: Array.isArray(newsItem?.reactions) ? {} : newsItem.reactions,
	draft: newsItem.draft === 1 ? true : !!newsItem.draft,
});

export const getNews = async (query: any) => backend
	.get(`${BASE}/`, {
		params: query,
	})
	.then((result) =>
		// @ts-ignore
		result.map(newsItemFromBE));

export const postNewsItem = async (data: INewsItemSnapshotIn) => backend.post(`${BASE}`, data);

export const getNewsItem = async (id: number) => backend.get(`${BASE}/${id}`).then(newsItemFromBE);

export const updateNewsItem = async (id: number, data: any) => backend.post(`${BASE}/${id}`, data).then(newsItemFromBE);

export const deleteNewsItem = async (id: number) => backend.delete(`${BASE}/${id}`);

export const toogleReaction = async (id: number, data: { reaction: string }) => backend.post(`${BASE}/${id}/reactions/toggle`, data);
